export default __webpack_public_path__ + "static/media/19.a488db70.jpeg";